import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFitbitComponent } from './simple-icons-fitbit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFitbitComponent ],
    exports:      [ SimpleIconsFitbitComponent ],
    bootstrap:    []
})
export class SimpleIconsFitbitModule {}
